import React, { forwardRef } from 'react';
import { css, cx } from '@emotion/css';
import { expandFontTheme, useThemeContext, addFontThemePrefix, getPrefixedThemeColor, } from '@contrast-security-inc/design-system-foundations';
const textStyles = (font, color, selectedTheme) => {
    const resolvedColor = color ? getPrefixedThemeColor(color) : 'inherit';
    return css `
    ${expandFontTheme(addFontThemePrefix(selectedTheme, font))};
    color: ${resolvedColor};
  `;
};
export const Text = forwardRef(({ as = 'span', color, children, className, font, testId, ...rest }, ref) => {
    if (color && !getPrefixedThemeColor(color)) {
        throw new Error(`Invalid text color, valid color must be a theme or darkTheme color, and you passed in ${color}.`);
    }
    const { selectedTheme } = useThemeContext();
    const classes = cx(textStyles(font ?? 'body', color, selectedTheme), className, 'ds-text');
    return React.createElement(as || 'span', {
        className: classes,
        'data-testid': testId,
        ref,
        ...rest,
    }, children);
});
Text.displayName = 'Text';
